import styled from '@src/styled-components';
import React from 'react';
import { Button, Modal, Slider, Icon } from 'antd';
import I18n from '@src/i18n';


export interface ISampleImageExecutionProps {
  description: string;
  image: string;
}

interface ISampleImageExecutionState {
  zoomSize: string;
  visibleModal: boolean;
}
export default class SampleImageExecutionComponent extends React.Component<ISampleImageExecutionProps, ISampleImageExecutionState> {
  constructor(props: ISampleImageExecutionProps) {
    super(props);

    this.state = {
      zoomSize: '30',
      visibleModal: false
    }
    this.handleZoom = this.handleZoom.bind(this)
  }
  handleZoom(e: any){ this.setState({zoomSize: e}) }
  handleVisibleModal(){ this.setState({visibleModal: !this.state.visibleModal}) }
  render() {
    return (
      <Wrapper>
        <p>{this.props.description}</p>
        <img src={this.props.image} alt="image" className="center" />
        <Modal width={'90%'} style={{ top: '20px' }} footer={false} visible={this.state.visibleModal}
        onCancel={()=>this.handleVisibleModal()}
        >
          <ZoomContainer size={this.state.zoomSize} >
            <img src={this.props.image} alt="image" className='imgZoom' />
          </ZoomContainer>
          <SliderContainer>
            <div className='SliderBox'>
              <Icon type='zoom-in'/>
              <Slider min={30} defaultValue={30} onChange={this.handleZoom}/>
              <Icon type='zoom-out'/>
            </div>
          </SliderContainer>
        </Modal>
        <Button onClick={()=>this.handleVisibleModal()} type='link' > {I18n.l('common.visualize')}</Button>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
padding-bottom: 21px;
  .button-style{
    margin-right: 20px;
  }
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }
`
const ZoomContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-height: 100%
  .imgZoom{
    width: ${props => props.size}%;
  }
`;
const SliderContainer = styled.div`
    position: fixed;
    bottom: 20px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    .SliderBox{
      &:hover{
        opacity: 1
        transition: .3s linear
      }
      opacity:0.3
      display: flex;
      background: white;
      border-radius: 5px;
      align-items: center;
      justify-content: space-around;
      width: 300px;
      .ant-slider{
        width: 60%;
      }
    }
`;